package org.zq.flvtomp4.converter

data class ConvertRequest(
    val taskId: String,
    val inputPath: String,
    val outputPath: String,
    val mode: ConvertMode = ConvertMode.SMART,
    val quality: Int = 20,
    val overwrite: Boolean = false,
)
